<p>
  This membership has <b>{{ membership.days_remaining }} days</b> remaining. When the membership is eventually unfrozen, its end date will be set to {{ membership.days_remaining }} days after the unfreeze date.
</p>

<div class="form-group" *ngIf="orgConfig.getOrganizationConfig().require_membership_freeze_reason">
  <label for="reasonSelect">Freeze Reason</label>
  <select class="custom-select"
          name="reason" id="reasonSelect"
          [(ngModel)]="reason">
    <option [ngValue]="null" disabled>---</option>
    <option *ngFor="let reasonOption of orgConfig.getOrganizationConfig().membership_freeze_reason_options"
            [ngValue]="reasonOption">{{ reasonOption }}</option>
  </select>
</div>

<p *ngIf="loadingFee" class="text-muted">Loading freeze fee...</p>

<ng-container *ngIf="feeWithTax && !loadingFee">
  <ng-container *ngIf="hasFee">
    <p>
      Base freeze fee: {{ orgConfig.getCurrencySymbol() }}{{ feeWithTax.base }} <br>
      Tax: {{ orgConfig.getCurrencySymbol() }}{{ feeWithTax.tax }} <br>
      <br>
      Total amount due: {{ orgConfig.getCurrencySymbol() }}{{ feeWithTax.total }}
    </p>
    <div *ngIf="membership.payment_processor_connection_id === null"
         class="alert alert-danger">
      No Payment Processor Configured
    </div>
  </ng-container>
  <p *ngIf="!hasFee">No freeze fee due.</p>
</ng-container>

<div class="alert alert-danger" role="alert" *ngIf="errorMessage">
  {{ errorMessage }}
</div>
